"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactLoadable = require("react-loadable");

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Loading = function Loading() {
  return _react2.default.createElement(
    "div",
    null,
    "Loading..."
  );
};

// Dynamic import function for components

var CreationModule = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/CreationModule");
  },
  loading: Loading
});

// Example route configuration
var routes = [{
  path: "page-creation",
  component: CreationModule,
  needsAuthentication: true,
  options: {
    hideFooter: true,
    title: "CreationModule",
    hideTitle: true,
    hideBackButton: true
  }
}];

exports.default = routes;


//////////////////
// WEBPACK FOOTER
// ../lib/page-creation/Routes/module-routes.js
// module id = 3522
// module chunks = 1137